import { Link } from "react-router-dom";
import React from "react";


function Footer() {
  
    return (
        <div>
        <footer id="footer">
    <div className="footer-top">
      <div className="container">
        <div className="row">

          <div className="col-lg-3 col-md-6 footer-info">
            <img src={"../assets/img/cfplogo-white.png"} alt="Cheap Flights Prices" />
            <p>Cheapflightsprices is a travel portal. By using cheapflightsprices.com, you agree that Cheapflightsprices is not accountable for any loss - direct or indirect, arising of offers, materials or links to other sites found on this website. In case of queries, reach us directly at</p>
<br/>
              <p>
              <strong>Email : </strong><a href="mailto:cheapflightsprices@gmail.com">cheapflightsprices@gmail.com</a>
            </p>
<br/>
            <div className="social-links">
              <a href="https://twitter.com/prices_cheap" className="twitter"><i className="bi bi-twitter"></i></a>
              <a href="https://www.facebook.com/Cheapflightsprices/" className="facebook"><i className="bi bi-facebook"></i></a>
              <a href="https://www.instagram.com/Cheapflightsprices" className="instagram"><i className="bi bi-instagram"></i></a>
              <a href="https://in.pinterest.com/Cheapflightsprices" className="pinterest"><i className="bi bi-pinterest"></i></a>
              <a href="https://www.linkedin.com/company/cheap-flights-prices/" className="linkedin"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>
            <div className="col-lg-3 col-md-6 footer-links">
           <h4>Top Airlines</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="/airlines/american-airlines.html">American Airlines</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/airlines/lufthansa.html">Lufthansa</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/airlines/united-airlines.html">United Airlines</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/airlines/jetblue-airways.html">jetBlue Airways</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/airlines/turkish-airlines.html">Turkish Airlines</a></li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 footer-links">
            <h4>Company</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="/about-us.html">About Us</a></li>

              <li><i className="bi bi-chevron-right"></i> <a href="/terms-and-conditions.html">Terms of service</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/privacy-policy.html">Privacy policy</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/disclaimer.html">Disclaimer</a></li>
          <li><i className="bi bi-chevron-right"></i> <a href="/refund-cancellation-policy.html">Refund &amp; Cancellation Policy</a></li>

            </ul>
          </div>

          <div className="col-lg-3 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <a href="/">Flight Booking</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/hotels.html">Hotel Booking</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/contact-us.html">Contact Us</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="/site-map.html">Sitemap</a></li>
              <li><i className="bi bi-chevron-right"></i> <a href="https://cheapflightsprices.com/blog">Latest Blog Post</a></li>

            </ul>
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="copyright">
        &copy; Copyright 2018 - <span id="currentsYrs"></span> Cheap Flights Prices. All Rights Reserved.
      </div>
    </div>
  </footer>
      <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
        </div>
        
    );
}
export default Footer;
